import { Select } from '@ardoq/select';
import { ReactElement, ReactNode } from 'react';
import { ListEditorPropsWithOptionsGroups } from 'scopeData/editors/types';

const getLabel = (label: string | ReactElement<{ children?: ReactNode[] }>) => {
  if (typeof label === 'string') {
    return label.toLowerCase();
  }
  if (
    typeof label === 'object' &&
    label.props &&
    label.props.children &&
    typeof label.props.children[0] === 'string'
  ) {
    // apps/ardoq-front/src/js/ardoq/views/selectViews/selectViews.tsx::getViewOptionLabel
    return label.props.children[0].toLowerCase();
  }
  return String(label);
};

const List = ({
  label,
  value,
  description,
  dataClickId,
  options,
  onValueChange,
  isDisabled,
  disabledMessage,
  isClearable,
  popoverHelpContent,
  onCloseFieldClick,
  closeFieldIconTooltip,
  errorMessages,
  i18nLocale,
  preventBodyScroll,
}: ListEditorPropsWithOptionsGroups) => {
  return (
    <Select
      value={value ?? null}
      label={label}
      options={options}
      onValueChange={onValueChange}
      isDisabled={isDisabled}
      preventBodyScroll={preventBodyScroll}
      helperText={isDisabled ? disabledMessage : description}
      isClearable={isClearable}
      clickId={dataClickId}
      popoverHelpContent={popoverHelpContent}
      errorMessage={errorMessages?.[0] as string}
      i18nLocale={i18nLocale}
      filterOption={({ value, label }, query) => {
        const lowercaseQuery = query?.toLowerCase() ?? '';
        // other than a string, value could be null/number/boolean
        const lowercaseValue =
          value !== null ? String(value).toLowerCase() : '';
        const lowercaseLabel = getLabel(label);
        return (
          lowercaseLabel.includes(lowercaseQuery) ||
          lowercaseValue.includes(lowercaseQuery)
        );
      }}
      onCloseFieldClick={onCloseFieldClick}
      closeFieldIconTooltip={closeFieldIconTooltip}
    />
  );
};

export { List };
